import {LitElement, html, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../store';
import {getFeature} from '../../util/values';
import {getProductData} from '../../util/getProductData';

@customElement('feature-assistant-list-select')
export class FeatureAssistentListSelect extends connect(store)(LitElement) {

	@property({type: Object})
	title = null;

	@property({type: Boolean})
	hideDisabled = false

	@property({type: String})
	feature = null;

	static styles = [
		css`
			:host {
				width: var(--assistant-widget-width);
			}
			.title {
				display: flex;
				align-items: center;
				font: var(--font-widget-big-title);
				color: var(--color-widget-text);
				line-height: 1.4;
				margin-bottom: 40px;
			}
			.values {
				display: flex;
				flex-direction: column;
				border: none;
				gap: 8px
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;

		this.productData = state.productData.productData ?? [];
		this.featureProductData = getProductData('LE_ColourTemperature_1', this.productData);

		this.features = state.featureModel.data.features ?? [];
		this.feature = getFeature('LE_ColourTemperature_1', this.features);

		this.decisions = state.decisions.data;
		this.lang = state.status.lang;
	}
	isSatisfied() {
		return (this.feature.variableId in this.decisions.normalizedFeatures && this.decisions.normalizedFeatures[this.feature.variableId].isSatisfied);
	}
	render() {
		const s = store.getState();
		const options = repeat([...this.feature.values]
								// .filter(value => !value.disabled)
								.sort((a, b) => this.featureProductData?.displaySequenceUi - this.featureProductData?.displaySequenceUi),
						(featureValue) => featureValue.featureValueId,
						(featureValue) => html`
							<feature-assistant-list-select-item
								.feature=${this.feature}
								.featureValue=${featureValue}
								.hideDisabled=${this.hideDisabled}
								.productData=${this.featureProductData}>
							</feature-assistant-list-select-item>
                        `);
		return html`
			<div>
				<div class="title">
					${when(this.title !== null, () => html`
						<span>${this.title[this.lang]}</span>
					`, () => html`
						<trans-label
							key="${this.feature.variableId}"
							context="F"
							title="${this.feature.variableId}">
						</trans-label>
					`)}

				</div>
				<div class="values ${classMap({notSatisfied: !this.isSatisfied(s)})}">
					${options}
				</div>
			</div>

		`;
	}
}
